'use client'

import { useEffect, useRef } from 'react'

import { Navigate } from 'react-router-dom'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import {
  ConversationInitiatorType,
  CONVERSATION_URL,
} from '@marketplace-web/messaging/conversation-messaging-data'

import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { useCreateConversation } from '@marketplace-web/messaging/conversation-messaging-api-resolvers-feature'

const FavoritedItemConversationLoader = () => {
  const queryParams = useBrowserNavigation().searchParams
  const isCreateConversationInitiated = useRef(false)

  const { conversation, createConversation } = useCreateConversation()

  useEffect(() => {
    const createConversationFromNotification = () => {
      const itemId = queryParams.item_id?.toString()
      const receiverId = queryParams.receiver_id?.toString()
      if (itemId && receiverId && !isCreateConversationInitiated.current) {
        isCreateConversationInitiated.current = true
        createConversation({
          itemId,
          receiverId,
          initiator: ConversationInitiatorType.SellerEntersNotification,
        })
      }
    }

    createConversationFromNotification()
  }, [createConversation, queryParams])

  if (!conversation) return <ContentLoader testId="conversation-page-loader" />

  return <Navigate to={CONVERSATION_URL(conversation.id)} replace />
}

export default FavoritedItemConversationLoader
